import React, { useEffect, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { format, max } from 'date-fns';
import {
    RadioGroup,
    FormControlLabel,
    Radio,
    FormHelperText,
    TextField,
    Checkbox,
} from '@material-ui/core';
import _ from 'lodash';
import IconButton from '@material-ui/core/IconButton';
import Box from '@material-ui/core/Box';
import { useIntl, FormattedMessage } from 'react-intl';
import { makeStyles } from '@material-ui/core/styles';
import { useParams, useHistory } from 'react-router-dom';
import CustomTypography from '../../../components/Typography/CustomTypography';
import Validation from '../../../common/Validation';
import Button from '../../../components/Button/CustomButton';
import styles from '../../../assets/jss/pages/detailCompanyStyle';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import FormDialog from '../../../components/Dialog/FormDialog';
import SelectorInput from '../../../components/Input/SelectorInput';
import CleanableInput from '../../../components/Input/CleanableInput';
import UploadButton from '../../../components/Button/UploadButton';
import { locationOption } from '../../../common/Constants';
import Pricing from '../../../components/Pricing/Pricing';
import DateLimit from '../../../components/DatePicker/DateLimit';
import { Trash, IndeterminateCheckBoxIcon, AddBoxIcon } from '../../../components/Icons/Icon';
import CustomTable from '../../../components/Table/Table';
import dateUtils from '../../../utils/dateUtils';
import SnackBar from '../../../components/Snackbar/Snackbar';
import AlertDialog from '../../../components/Dialog/AlertDialog';
import SingleDatePickerSearch from '../../../components/DatePicker/SingleDatePickerSearch';
import TimeRanger from '../../../components/DatePicker/TimeRanger';
import SeminarService from '../../../services/seminar';

const useStyles = makeStyles(styles);
const noRegis = '申し込んでいません。';
const checkDuplicate = (newRoom, roomTimes) => {
    for (let index = 0; index < roomTimes.length; index += 1) {
        if (
            roomTimes[index].date === newRoom.date
            && roomTimes[index].room === newRoom.room
            && roomTimes[index].stime === newRoom.stime
            && roomTimes[index].etime === newRoom.etime
            && roomTimes[index].roomMoney === newRoom.roomMoney
        ) {
            return false;
        }
    }
    return true;
};

const formatDate = (data) => (format(new Date(data), 'yyyy-MM-dd'));
const formatDateSeminar = (data) => (format(new Date(data), 'yyyy/MM/dd'));

const DialogEditCompany = (props) => {
    const {
        isOpen,
        handleClose,
        companyDetail,
        fetchEditCompany,
        room,
        getInformationRoom,
        eventInfo,
        errorEdit,
        fetchDeleteCompany,
        deleteSuccess,
        clearDeleteCompany,
        options,
        fetchJobs,
        jobs,
        fetchCategory,
        category,
        zones,
        eventStartDate,
        eventEndDate,
        fetchClearEditCompany,
        errorDeleteCompany,
        getOccupations,
        occupations,
        clearOccupations,
    } = props;
    const classes = useStyles();
    const urlParams = useParams();
    const history = useHistory();
    const intl = useIntl();
    const [params, setParams] = useState({});
    const [validateResults, setValidateResults] = useState({});
    const [previewImage, setPreviewImage] = useState('');

    const [optionRoom, setOptionRoom] = useState({});
    const [optionRoomMoney, setOptionRoomMoney] = useState({});
    const [optionTime, setOptionTime] = useState({});
    const [roomTime, setRoomTime] = useState([]);
    const [currentTimeSeminar, setCurrentTimeSeminar] = useState([]);
    const [listEventState, setListEventState] = useState([]);
    const [seminarDetails, setSeminarDetails] = useState([]);
    const [isOpenDialogDelete, setIsOpenDialogDelete] = useState({ isOpen: false, noDel: false });
    const [snackbar, setSnackbar] = useState({ isOpen: false, type: 'success', message: '' });
    const [listOptionCompanyFromApi, setListOptionCompanyFromApi] = useState({});
    const [listOptionEmployeeNumberFromApi, setOptionEmployeeNumberFromApi] = useState({});
    const [jobStates, setJobState] = useState({});
    const [categoryState, setCategoryState] = useState({});
    const [occupationStates, setOccupationState] = useState({});
    const [listZoneFromApi, setListZoneFromApi] = useState({});

    const [listDateDisable, setListDateDisable] = useState([]);
    const [validateResultsLiveStream, setValidateResultsLiveStream] = useState({});
    const [tempDate, setTempDate] = useState('');
    const [tempIndex, setTempIndex] = useState('');
    const [dataTableLiveStream, setDateTableLiveStream] = useState([]);
    const [paramsLivestream, setParamsLivestream] = useState([]);
    const [defaultParamsLiveStream, setDefaultPramsLiveStream] = useState({
        title: '',
        speaker: '',
        stime: format(new Date(), 'HH:mm'),
        etime: format(new Date(), 'HH:mm'),
        dates: [format(new Date(), 'yyyy-MM-dd')],
        cost: 0,
    });
    const [liveStreamTable, setLiveStreamTable] = useState([]);
    const [availableDates, setAvailableDates] = useState([]);

    useEffect(() => {
        const { shortName } = urlParams;
        fetchJobs(shortName);
        fetchCategory(shortName);
        getOccupations({ shortName });

        try {
            SeminarService.getAvailableDates(shortName)
                .then((res) => {
                    const arrDate = Object.keys(res);

                    setAvailableDates(arrDate);
                });
        } catch {
            setAvailableDates([]);
        }

        return () => {
            fetchClearEditCompany();
            clearOccupations();
        };
    }, []);

    // Set room from api
    useEffect(() => {
        let temp = {};
        let temp1 = {};
        let temp2 = '';
        Object.keys(room).forEach((key, i) => {
            if (!i) {
                temp2 = key;
            }
            temp = { ...temp, [key]: key };
            temp1 = { ...temp1, [key]: `${key} ( ${room[`${key}`].price}円 )` };
        });

        setOptionRoom(temp);
        setOptionRoomMoney(temp1);

        if (temp[temp2]) {
            const timer = room[temp[temp2]];
            let timeRoomOptions = {};
            if (timer.times) {
                timer.times.forEach((key, i) => {
                    timeRoomOptions = { ...timeRoomOptions, [i]: `${key.stime}~${key.etime}` };
                });
            }
            setOptionTime(timeRoomOptions);
            setParams({
                ...params,
                timeSeminar: timeRoomOptions[0],
                roomSeminar: temp[temp2],
                roomSeminarMoney: temp1[temp2],
            });
        }
    }, [room]);

    // Set list Option Company
    useEffect(() => {
        if (options && options.company_option) {
            let temp = {};
            options.company_option.forEach((key, i) => {
                temp = { ...temp, [i]: key[i] };
            });
            setListOptionCompanyFromApi({ ...listOptionCompanyFromApi, ...temp });
        }
    }, [options]);

    // Set list employee_number
    useEffect(() => {
        if (options && options.employee_number_option) {
            let temp = {};
            options.employee_number_option.forEach((key, i) => {
                temp = { ...temp, [i]: key[i] };
            });
            setOptionEmployeeNumberFromApi({ ...listOptionEmployeeNumberFromApi, ...temp });
        }
    }, [options]);

    // Set room select when has room
    useEffect(() => {
        if (optionRoom) {
            const temp = Object.keys(optionRoom)[0];
            setParams({ ...params, roomSeminar: optionRoom[temp], roomSeminarMoney: optionRoomMoney[temp] });
        } else {
            setParams({ ...params, roomSeminar: '', roomSeminarMoney: '' });
        }
    }, [optionRoom]);

    // Set time when has room
    useEffect(() => {
        if (params.roomSeminar) {
            const timer = room[params.roomSeminar];
            let temp = {};
            if (timer.times) {
                timer.times.forEach((key, i) => {
                    temp = { ...temp, [i]: `${key.stime}~${key.etime}` };
                });
            }
            setOptionTime(temp);
            setParams({ ...params, timeSeminar: temp[0] });
        } else {
            setOptionTime([]);
            setParams({ ...params, timeSeminar: '' });
        }
    }, [params.roomSeminar]);

    // Set data table when room select
    useEffect(() => {
        if (!_.isEmpty(roomTime)) {
            const tableData = roomTime.map((item, index) => [
                formatDateSeminar(item.date),
                `${item.stime}~${item.etime}`,
                item.roomMoney,
                <IconButton
                    onClick={() => removeRoomTime(index)}
                >
                    <Trash />
                </IconButton>,
            ]);
            setListEventState(tableData);
        }
    }, [roomTime]);

    const addRoomTime = () => {
        const {
            dateSeminar, timeSeminar, roomSeminar, roomSeminarMoney,
        } = params;
        if (dateSeminar && timeSeminar && roomSeminar && roomSeminarMoney) {
            const stateTime = timeSeminar.split('~')[0];
            const endTime = timeSeminar.split('~')[1];
            const newRoom = {
                date: dateSeminar,
                room: roomSeminar,
                stime: stateTime,
                etime: endTime,
                roomMoney: roomSeminarMoney,
            };
            if (checkDuplicate(newRoom, [...currentTimeSeminar, ...roomTime])) {
                setRoomTime([...roomTime, newRoom]);
            }
        }
    };

    const removeRoomTime = (index) => {
        const roomUpdate = roomTime;
        roomUpdate.splice(index, 1);
        setRoomTime([...roomUpdate]);
    };

    const removeLiveStream = (index) => {
        const liveStreamUpdate = paramsLivestream;
        const removeListDateDisable = paramsLivestream[index].dates;
        const tempListDateDisable = [];
        listDateDisable.forEach(item => {
            if (!removeListDateDisable.includes(item)) tempListDateDisable.push(item);
        });
        liveStreamUpdate.splice(index, 1);
        setParamsLivestream([...liveStreamUpdate]);
        setListDateDisable([...tempListDateDisable]);
    };

    useEffect(() => {
        if (params.dateSeminar && eventInfo) {
            const eventName = eventInfo.short_name;
            const date = format(new Date(params.dateSeminar), 'yyyy-MM-dd');
            getInformationRoom({ shortName: eventName, date });
        }
    }, [params.dateSeminar, getInformationRoom]);

    // Set list event zone ***
    useEffect(() => {
        if (zones.length) {
            let temp = {};
            zones.forEach((key) => {
                temp = { ...temp, [`${key.id}`]: key.name };
            });
            setListZoneFromApi({ ...listZoneFromApi, ...temp });
        }
    }, [zones]);

    useEffect(() => {
        if (!_.isEmpty(listZoneFromApi)) {
            handleSetParams('zone', Number(Object.keys(listZoneFromApi)[0]));
        }
    }, [listZoneFromApi]);

    useEffect(() => {
        if (tempDate && !_.isUndefined(tempIndex) && !_.isEmpty(defaultParamsLiveStream.dates)) {
            const tempArrDate = [];
            defaultParamsLiveStream.dates.forEach((item, index) => {
                if (index === tempIndex) {
                    tempArrDate.push(tempDate);
                } else {
                    tempArrDate.push(item);
                }
            });
            setDefaultPramsLiveStream({ ...defaultParamsLiveStream, dates: tempArrDate });
            setTempDate('');
            setTempIndex('');
        }
    }, [tempDate, tempIndex]);

    useEffect(() => {
        if (!_.isEmpty(paramsLivestream)) {
            const tableData = paramsLivestream.map((item, index) => [
                item.title,
                `${item.stime}~${item.etime}`,
                (item.dates).map((date) => <p>{format(new Date(date), 'yyyy/MM/dd')}</p>),
                parseFloat(item.cost) === 0 ? '無料' : `${parseFloat(item.cost)}円`,
                <IconButton
                    onClick={() => removeLiveStream(index)}
                >
                    <Trash />
                </IconButton>,
            ]);
            setDateTableLiveStream(tableData);
        }
    }, [paramsLivestream]);

    const handleCloseSnackbar = () => {
        setSnackbar({ ...snackbar, isOpen: false });
    };

    useEffect(() => {
        if (isOpen) {
            const initialParams = {
                ...params,
                fullName: companyDetail.fullName,
                fullNameEN: companyDetail.fullNameEN,
                shortName: companyDetail.shortName,
                // shortNameEN: companyDetail.shortNameEN,
                companyType: companyDetail.companyType,
                companyCategory: companyDetail.companyCategory,
                image: companyDetail.image,
                department: companyDetail.department,
                url: companyDetail.url,
                position: companyDetail.position,
                location: companyDetail.location,
                address: companyDetail.address,
                addressEN: companyDetail.addressEN,
                email: companyDetail.email,
                firstName: companyDetail.firstName,
                lastName: companyDetail.lastName,
                description: companyDetail.description,
                descriptionEN: companyDetail.descriptionEN,
                zipCode: companyDetail.zipCode,
                phoneNumber: companyDetail.phoneNumber,
                faxNumber: companyDetail.faxNumber,
                dateSeminar: eventInfo.sdate,
                booth: companyDetail.booth,
                seminars: companyDetail.seminars,
                register_ads_max: companyDetail.register_ads_max,
                optionBooth: companyDetail.booth > 0 ? '1' : '0',
                optionSeminar: '0',
                optionLiveStream: '0',
                optionAds: companyDetail.register_ads_max > 0 ? '1' : '0',
                employee_number: companyDetail.employee_number,
                occupation: companyDetail.occupation,
                occupationName: companyDetail.occupationName,
                live_stream: companyDetail.live_stream,
                // eslint-disable-next-line no-nested-ternary
                has_payment: companyDetail.has_payment === 1 ? '1' : companyDetail.has_payment ? '2' : '0',
            };

            if (zones.length) {
                initialParams.zone = zones.filter((item) => item.id === companyDetail.zone)[0].id;
            }

            setParams(initialParams);
            setPreviewImage(companyDetail.image && companyDetail.image.concat('?=', new Date().getTime().toString()));
            setDateTableLiveStream([]);
            setCurrentTimeSeminar([]);
            setParamsLivestream([]);
        } else {
            setParams({});
            setValidateResults({});
            setValidateResultsLiveStream({});
            setRoomTime([]);
            setDateTableLiveStream([]);
        }
    }, [isOpen]);

    useEffect(() => {
        if (!_.isEmpty(companyDetail.live_stream)) {
            const tableData = companyDetail.live_stream.map((item) => [
                item.title,
                `${item.stime}~${item.etime}`,
                (item.dates).map((date) => <p>{format(new Date(date), 'yyyy/MM/dd')}</p>),
                item.cost === 0 ? '無料' : `${intl.formatNumber(item.cost)}円`,
            ]);
            companyDetail.live_stream.map((item) => [
                (item.dates).map((date) => listDateDisable.push(date)),
            ]);
            setLiveStreamTable(tableData);
            setListDateDisable([...listDateDisable]);
        }
    }, [companyDetail.live_stream, isOpen]);

    const validate = () => {
        const {
            fullName, shortName, companyType, department, position, firstName, lastName, location, address, url,
            description, phoneNumber, faxNumber, zipCode, register_ads_max, optionAds, employee_number, occupationName, has_payment,
            fullNameEN, shortNameEN, addressEN, descriptionEN,
        } = params;

        const validateRules = {
            company_full_name: [
                () => Validation.isNotEmpty(fullName),
                () => Validation.validateMaxLength(fullName, 60),
            ],
            company_short_name: [
                () => Validation.isNotEmpty(shortName),
                () => Validation.validateMaxLength(shortName, 60),
            ],
            company_type: [
                () => Validation.isNotEmpty(companyType),
            ],
            department: [
                () => Validation.validateMaxLength(department, 255),
            ],
            position: [
                () => Validation.validateMaxLength(position, 255),
            ],
            first_name: [
                () => Validation.isNotEmpty(firstName),
                () => Validation.validateMaxLength(firstName, 255),
            ],
            last_name: [
                () => Validation.isNotEmpty(lastName),
                () => Validation.validateMaxLength(lastName, 255),
            ],
            location: [
                () => Validation.validateMaxLength(location, 255),
            ],
            zip_code: [
                () => Validation.isNotEmpty(zipCode),
                () => Validation.validateMaxLength(zipCode, 255),
            ],
            address: [
                () => Validation.isNotEmpty(address),
                () => Validation.validateMaxLength(address, 1000),
            ],
            phoneNumber: [
                () => Validation.isNotEmpty(phoneNumber),
                () => Validation.validateMaxLength(phoneNumber, 255),
                () => Validation.validatePhoneNumber(phoneNumber && phoneNumber.trim()),
            ],
            fax_number: [
                () => Validation.validateMaxLength(faxNumber, 255),
            ],
            url: [
                () => Validation.validateMaxLength(url, 500),
                () => Validation.isValidUrl(url),
            ],
            description: [
                () => Validation.isNotEmpty(description),
                () => Validation.validateMaxLength(description, 1000, 'textarea'),
            ],
            register_ads_max: [optionAds > 0 ? () => Validation.limitValue(register_ads_max, 0, eventInfo.register_ads_max) : () => { }],

            employee_number: [() => Validation.isNotEmpty(listOptionEmployeeNumberFromApi[employee_number]),
                () => Validation.validateMaxLength(employee_number, 255)],
            occupation_name: [
                () => Validation.isNotEmpty(occupationName),
            ],
            has_payment: [() => Validation.isNumberNotZero(+has_payment)],
        };
        if (!_.isEmpty(eventInfo.languages)) {
            validateRules.company_full_name_en = [
                () => Validation.isNotEmpty(fullNameEN),
                () => Validation.validateLatin(fullNameEN),
                () => Validation.validateMaxLength(fullNameEN, 60),
            ];
            // validateRules.company_short_name_en = [
            //     () => Validation.isNotEmpty(shortNameEN),
            //     () => Validation.validateLatin(shortNameEN),
            //     () => Validation.validateMaxLength(shortNameEN, 60),
            // ];
            validateRules.address_en = [
                () => Validation.isNotEmpty(addressEN),
                () => Validation.validateLatin(addressEN),
                () => Validation.validateMaxLength(addressEN, 1000),
            ];
            validateRules.description_en = [
                () => Validation.isNotEmpty(descriptionEN),
                () => Validation.validateLatin(descriptionEN),
                () => Validation.validateMaxLength(descriptionEN, 1000, 'textarea'),
            ];
        }
        const validateResult = Validation.validateAllRules(validateRules);

        if (Object.keys(validateResult).length > 0) {
            setValidateResults({ ...validateResult });
            window.scrollTo(0, 0);
            return false;
        }
        setValidateResults({});
        return true;
    };

    const validateLiveStream = () => {
        const {
            title, speaker, stime, etime, dates, cost,
        } = defaultParamsLiveStream;

        const validateRules = {
            title: [
                () => Validation.isNotEmpty(title),
                () => Validation.validateMaxLength(title, 500),
            ],
            speaker: [
                () => Validation.isNotEmpty(speaker),
                () => Validation.validateMaxLength(speaker, 255),
            ],
            cost: [
                () => Validation.isNotEmpty(cost),
            ],
            dates: [
                () => Validation.validateSelectionDates(dates, listDateDisable),
                () => Validation.validateDuplicateDates(dates),
            ],
            rangerTime: [
                () => Validation.validateTimeRanger(stime, etime),
                () => Validation.validateTimeSame(stime, etime),
                () => Validation.validateStartTime(stime, dates),
            ],
        };
        const validateResult = Validation.validateAllRules(validateRules);

        if (Object.keys(validateResult).length > 0) {
            setValidateResultsLiveStream({ ...validateResult });
            window.scrollTo(0, 0);
            return false;
        }
        setValidateResultsLiveStream({});
        return true;
    };

    const renderBoothType = (type) => {
        switch (type) {
            case 1:
                return _.get(eventInfo, 'setting_booth.small_zone.name');
            case 2:
                return _.get(eventInfo, 'setting_booth.standard_zone.name');
            case 3:
                return _.get(eventInfo, 'setting_booth.big_zone.name');
            case 4:
                return _.get(eventInfo, 'setting_booth.grand_zone.name');
            default:
                return 'この催しに展示会を開催することができません。';
        }
    };
    useEffect(() => {
        if (errorEdit && errorEdit.code === 'BAD_REQUEST') {
            setValidateResults({
                ...validateResults,
                ...errorEdit,
            });
            setValidateResultsLiveStream({
                ...validateResultsLiveStream,
                ...errorEdit,
            });
            if (errorEdit.non_field_errors) {
                setSnackbar({
                    isOpen: true,
                    type: 'error',
                    message: errorEdit.non_field_errors.message,
                });
            }
            if (errorEdit.message) {
                setSnackbar({
                    isOpen: true,
                    type: 'error',
                    message: errorEdit.message.message,
                });
            }
        } else {
            setSnackbar({
                isOpen: false,
            });
        }
    }, [errorEdit]);

    useEffect(() => {
        if (!_.isEmpty(jobs)) {
            setJobState(_.reduce(jobs, (result, value) => ({ ...result, [value]: value }), { '': '' }));
        }
    }, [jobs]);

    useEffect(() => {
        if (!_.isEmpty(category)) {
            setCategoryState(_.reduce(category, (result, value) => ({ ...result, [value]: value }), { "":""}));
            console.log('checkk2...categoryState:', categoryState);
        }else{
            setCategoryState({"test1":category.length});
        }
    }, [category]);

    useEffect(() => {
        if (!_.isEmpty(occupations)) {
            setOccupationState(_.reduce(occupations, (result, value) => ({ ...result, [value]: value }), { '': '' }));
        }
    }, [occupations]);

    const handleSetParams = useCallback((field, valueChange) => {
        setParams((prevParams) => ({ ...prevParams, [field]: valueChange }));
    }, []);

    const handleSeDefaultParamsLiveStream = useCallback((field, valueChange) => {
        setDefaultPramsLiveStream((prevParams) => ({ ...prevParams, [field]: valueChange }));
    }, []);

    const handleUploadImage = (file) => {
        setParams({ ...params, image: file, isChangeImage: true });
    };

    const handleEditCompany = () => {
        if (validate()) {
            setListDateDisable([]);
            fetchEditCompany({
                ...params,
                event_name: urlParams.shortName,
                company_id: urlParams.idCompany,
                zipCode: params.zipCode,
                phoneNumber: params.phoneNumber,
                faxNumber: params.faxNumber,
                seminars: roomTime,
                live_stream: paramsLivestream,
                payment_method: +params.has_payment,
            });
        }
    };

    const actionsButton = () => (
        <>
            <Box style={{ margin: 'auto' }}>

                <Button
                    autoFocus
                    gradient
                    onClick={handleEditCompany}
                    size="md"
                    color="success"
                    style={{ width: '200px', fontSize: '20px', left: ' 20%' }}
                >
                    <FormattedMessage id="save" />
                </Button>
                <Button
                    autoFocus
                    gradient
                    onClick={handleClose}
                    size="md"
                    color="danger"
                    style={{ width: '150px', marginRight: '10px', left: ' 80%' }}
                >
                    <FormattedMessage id="cancel" />
                </Button>
            </Box>
        </>
    );
    const handleChangeOptionBooth = (value) => {
        handleSetParams('optionBooth', value);
        handleSetParams('booth_change', value);
        if (value <= 0) {
            handleSetParams('booth', 0);
        }
    };
    const renderBooth = () => (
        <>
            <GridContainer className={classes.items}>
                <GridItem md={1} />
                <GridItem xs={12} md={3}>
                    <CustomTypography bold>
                        ブースタイプ
                    </CustomTypography>
                </GridItem>

                <GridItem xs={12} md={7}>
                    { Number(companyDetail.booth) === 0 && eventInfo.has_exhibition
                        ? (
                            <RadioGroup
                                aria-label="booth"
                                name="booth"
                                value={params.optionBooth}
                                onChange={(e) => handleChangeOptionBooth(e.target.value)}
                                row
                                className={classes.groupButton}
                            >
                                <FormControlLabel
                                    value="1"
                                    control={<Radio color="primary" />}
                                    label={<CustomTypography>する</CustomTypography>}
                                />

                                <FormControlLabel
                                    value="0"
                                    control={<Radio color="primary" />}
                                    label={<CustomTypography>しない</CustomTypography>}
                                    className={classes.label}
                                />

                            </RadioGroup>
                        ) : <CustomTypography>{renderBoothType(params.booth)}</CustomTypography>}
                </GridItem>
            </GridContainer>
            { (params.optionBooth > 0 && companyDetail.booth <= 0) && (
                <GridContainer justify="center">
                    <GridItem xs={12} md={10}>
                        <CustomTypography>
                            出展希望ブースは下部の〇にチェックを入れてください。
                        </CustomTypography>
                        <Pricing tiers={eventInfo.setting_booth} handleOption={(valueInput) => handleSetParams('booth', valueInput)}> </Pricing>
                    </GridItem>
                </GridContainer>
            )}
        </>
    );

    useEffect(() => {
        const { seminars } = companyDetail;
        if (seminars) {
            const arrData = [];
            const roomSeminar = [];
            seminars.forEach((element) => {
                arrData.push([
                    `${element.room} ( ${element.organization_price}円 )`,
                    dateUtils.formatJa(new Date(element.date)),
                    `${element.stime} ~ ${element.etime}`,
                ]);
                roomSeminar.push({
                    date: element.date,
                    room: element.room,
                    stime: element.stime,
                    etime: element.etime,
                    roomMoney: `${element.room} ( ${element.organization_price}円 )`,
                });
            });

            setSeminarDetails(arrData);
            setCurrentTimeSeminar(roomSeminar);
        } else {
            setSeminarDetails([]);
            setCurrentTimeSeminar([]);
        }
    }, [companyDetail.seminars]);

    const handleChangeSeminar = (value) => {
        handleSetParams('optionSeminar', value);
        handleSetParams('seminars_change', value);
        if (value <= 0) {
            setRoomTime([]);
        }
    };
    const handleDeleteCompany = () => {
        fetchDeleteCompany({
            event_name: urlParams.shortName,
            company_id: urlParams.idCompany,
        });
    };

    useEffect(() => {
        if (deleteSuccess) {
            setIsOpenDialogDelete({ isOpen: false, noDel: false });
            handleClose();
            history.push(`/admin/${urlParams.shortName}/company-event-management`);
            clearDeleteCompany();
        }
    }, [deleteSuccess]);

    useEffect(() => {
        if (!_.isEmpty(errorDeleteCompany)) {
            setSnackbar({ isOpen: true, type: 'error', message: errorDeleteCompany.message.message });
            setIsOpenDialogDelete({ isOpen: false, noDel: false });
            handleClose();
            clearDeleteCompany();
        }
    }, [errorDeleteCompany]);

    const renderSeminar = () => (
        <>
            <GridContainer className={classes.items}>
                <GridItem md={1} />
                <GridItem xs={12} md={3}>
                    <CustomTypography bold>
                        {(!_.isEmpty(params.seminars) && eventInfo.has_seminar) ? 'さらにセミナーを行いますか？' : 'セミナー利用の申込み'}
                    </CustomTypography>
                </GridItem>
                <GridItem xs={12} md={7}>
                    <RadioGroup
                        aria-label="seminar"
                        name="seminar"
                        value={params.optionSeminar}
                        onChange={(e) => handleChangeSeminar(e.target.value)}
                        row
                        className={classes.groupButton}
                    >
                        <FormControlLabel
                            value="1"
                            control={<Radio color="primary" disabled={!eventInfo.has_seminar} />}
                            label="する"
                        />
                        <FormControlLabel
                            value="0"
                            control={<Radio color="primary" disabled={!eventInfo.has_seminar} />}
                            label="しない"
                            className={classes.label}
                        />
                    </RadioGroup>
                </GridItem>
            </GridContainer>
            {params.optionSeminar > 0 && (
                <GridContainer justify="center">
                    <GridItem xs={12} md={10}>
                        <CustomTypography>
                            セミナー開催日、会議室、時間を選択してください。
                        </CustomTypography>
                        <fieldset className={classes.booth} style={{ minWidth: 'auto' }}>
                            <legend>
                                <CustomTypography variant="h5" color="primary" bold>セミナー情報</CustomTypography>
                            </legend>
                            <GridContainer>
                                <GridItem xs={12} md={12}>
                                    <GridContainer className={classes.padding10}>
                                        <GridItem xs={12} md={3}>
                                            <CustomTypography>
                                                開催日
                                            </CustomTypography>
                                        </GridItem>
                                        <GridItem xs={12} md={5}>
                                            <DateLimit
                                                sDate={eventInfo.sdate}
                                                eDate={eventInfo.edate}
                                                defaultValue={eventInfo.sdate}
                                                format="yyyy/MM/dd"
                                                onChange={(valueInput) => handleSetParams('dateSeminar', format(new Date(valueInput), 'yyyy-MM-dd'))}
                                                shouldDisableDate={disableDate}
                                            />
                                        </GridItem>
                                    </GridContainer>
                                    <GridContainer className={classes.padding10}>
                                        <GridItem xs={12} md={3}>
                                            <CustomTypography>
                                                会議室
                                            </CustomTypography>
                                        </GridItem>
                                        <GridItem xs={12} md={5}>
                                            <SelectorInput
                                                valueSelected={params.roomSeminar}
                                                optionList={optionRoomMoney}
                                                onChange={(valueInput) => {
                                                    handleSetParams('roomSeminar', optionRoom[valueInput]);
                                                    handleSetParams('roomSeminarMoney', optionRoomMoney[valueInput]);
                                                }}
                                            />
                                        </GridItem>
                                    </GridContainer>
                                    <GridContainer className={classes.padding10}>
                                        <GridItem xs={12} md={3}>
                                            <CustomTypography>
                                                時間帯
                                            </CustomTypography>
                                        </GridItem>
                                        <GridItem xs={12} md={5}>
                                            <SelectorInput
                                                valueSelected={params.timeSeminar}
                                                optionList={optionTime}
                                                onChange={(valueInput) => handleSetParams('timeSeminar', optionTime[valueInput])}
                                            />
                                        </GridItem>
                                    </GridContainer>

                                    <Box
                                        display="flex"
                                        flexDirection="column"
                                        justify="flex-end"
                                        alignItems="flex-end"
                                    >
                                        <Button color="info" gradient size="md" onClick={addRoomTime}>
                                            登録
                                        </Button>
                                    </Box>
                                    {roomTime.length > 0 && (
                                        <CustomTable
                                            tableHead={['月日', '時間', '会議室', 'アクション']}
                                            tableHeadWidth={['25%', '25%', '40%', '10%']}
                                            tableData={listEventState}
                                            className={classes.maxHeight}
                                            pointerLess
                                        />

                                    )}
                                </GridItem>
                                <FormHelperText error className={`MuiFormHelperText-contained ${classes.margin28}`}>
                                    {validateResults.seminars && validateResults.seminars.result
                                        ? intl.formatMessage({ id: validateResults.seminars.message }) : ''}
                                </FormHelperText>

                            </GridContainer>
                        </fieldset>
                    </GridItem>
                </GridContainer>
            )}
            {companyDetail.seminars && companyDetail.seminars.length > 0 && (
                <GridContainer>
                    <GridItem md={1} />
                    <GridItem xs={12} md={3} />
                    <GridItem xs={12} md={7}>
                        <CustomTable
                            tableHead={['会議室', '月日', '時間']}
                            tableHeadWidth={['30%', '40%', '30%']}
                            tableData={seminarDetails}
                            className={classes.tableEdit}
                            pointerLess
                        />
                    </GridItem>
                </GridContainer>
            )}
        </>
    );

    const handleChangeLiveStream = (value) => {
        setDefaultPramsLiveStream({
            title: '',
            speaker: '',
            stime: format(new Date(), 'HH:mm'),
            etime: format(new Date(), 'HH:mm'),
            dates: [format(new Date(), 'yyyy-MM-dd')],
            cost: 0,
        });
        handleSetParams('optionLiveStream', value);
    };

    const handleChangeDate = (sdate, index) => {
        setTempIndex(index);
        setTempDate(formatDate(sdate));
    };

    const disableDates = (date) => listDateDisable.includes(format(date, 'yyyy-MM-dd'));

    const addDate = () => {
        const date = formatDate(new Date());
        setDefaultPramsLiveStream({ ...defaultParamsLiveStream, dates: [...defaultParamsLiveStream.dates, date] });
    };

    const removeDate = (key) => {
        if (defaultParamsLiveStream.dates.length === 1) return;
        defaultParamsLiveStream.dates.splice(key, 1);
        const tempArrDate = defaultParamsLiveStream.dates;
        setDefaultPramsLiveStream({ ...defaultParamsLiveStream, dates: tempArrDate });
    };

    const changeCost = (e) => {
        if (/^\d*$/.test(e.target.value)) {
            setDefaultPramsLiveStream({ ...defaultParamsLiveStream, cost: (e.target.value) ? parseFloat(e.target.value) : 0 });
        }
    };

    const addLiveStream = () => {
        if (validateLiveStream()) {
            setListDateDisable([...listDateDisable, ...defaultParamsLiveStream.dates]);
            setParamsLivestream([...paramsLivestream, defaultParamsLiveStream]);
            setDefaultPramsLiveStream({
                title: '',
                speaker: '',
                stime: format(new Date(), 'HH:mm'),
                etime: format(new Date(), 'HH:mm'),
                dates: [format(new Date(), 'yyyy-MM-dd')],
                cost: 0,
            });
        }
    };

    const disableDate = (date) => {
        const formattedDate = format(new Date(date), 'yyyy-MM-dd');

        return !availableDates.includes(formattedDate);
    };

    const renderLiveStream = () => (
        <>
            <GridContainer className={classes.items}>
                <GridItem md={1} />
                <GridItem xs={12} md={3}>
                    <CustomTypography bold>
                        {(!_.isEmpty(params.live_stream) && eventInfo.has_live_stream) ? 'さらにライブ配信を行いますか？' : 'ライブ配信'}
                    </CustomTypography>
                </GridItem>
                <GridItem xs={12} md={7}>
                    <RadioGroup
                        aria-label="live_stream"
                        name="live_stream"
                        value={params.optionLiveStream}
                        onChange={(e) => handleChangeLiveStream(e.target.value)}
                        row
                        className={classes.groupButton}
                    >
                        <FormControlLabel
                            value="1"
                            control={<Radio color="primary" disabled={!eventInfo.has_live_stream} />}
                            label="する"
                        />
                        <FormControlLabel
                            value="0"
                            control={<Radio color="primary" disabled={!eventInfo.has_live_stream} />}
                            label="しない"
                            className={classes.label}
                        />
                    </RadioGroup>
                </GridItem>
            </GridContainer>

            {params.optionLiveStream > 0 && (
                <GridContainer justify="center">
                    <GridItem xs={12} md={10}>
                        <fieldset className={classes.booth} style={{ minWidth: 'auto' }}>
                            <legend>
                                <CustomTypography variant="h5" color="primary" bold>ライブ配信</CustomTypography>
                            </legend>
                            <GridContainer>
                                <GridItem xs={12} md={12}>
                                    <GridContainer className={classes.padding10}>
                                        <GridItem xs={12} md={3}>
                                            <CustomTypography required>
                                                タイトル
                                            </CustomTypography>
                                        </GridItem>
                                        <GridItem xs={12} md={9}>
                                            <CleanableInput
                                                defaultValue={defaultParamsLiveStream.title}
                                                onChange={(value) => handleSeDefaultParamsLiveStream('title', value)}
                                                error={!!validateResultsLiveStream.title}
                                                helperText={validateResultsLiveStream.title
                                                    ? intl.formatMessage({ id: validateResultsLiveStream.title.message }, { maxLength: 500 }) : ''}
                                            />
                                        </GridItem>
                                    </GridContainer>
                                    <GridContainer className={classes.padding10}>
                                        <GridItem xs={12} md={3}>
                                            <CustomTypography required>
                                                出演者
                                            </CustomTypography>
                                        </GridItem>
                                        <GridItem xs={12} md={9}>
                                            <CleanableInput
                                                defaultValue={defaultParamsLiveStream.speaker}
                                                onChange={(value) => handleSeDefaultParamsLiveStream('speaker', value)}
                                                error={!!validateResultsLiveStream.speaker}
                                                helperText={validateResultsLiveStream.speaker
                                                    ? intl.formatMessage({ id: validateResultsLiveStream.speaker.message }, { maxLength: 255 }) : ''}
                                            />
                                        </GridItem>
                                    </GridContainer>
                                    <GridContainer className={classes.padding10}>
                                        <GridItem xs={12} md={3}>
                                            <CustomTypography required>
                                                日程
                                            </CustomTypography>
                                        </GridItem>
                                        <GridItem xs={12} md={9} style={{ paddingLeft: '0px' }}>
                                            {
                                                defaultParamsLiveStream.dates.map((date, index) => (
                                                    <GridContainer>
                                                        <GridItem xs={6} md={6} style={{ marginBottom: '8px' }}>
                                                            <SingleDatePickerSearch
                                                                onChange={(date) => handleChangeDate(date, index)}
                                                                defaultValue={date}
                                                                format="yyyy/MM/dd"
                                                                error={!!validateResultsLiveStream.dates}
                                                                minDate={new Date(eventStartDate)}
                                                                maxDate={new Date(eventEndDate)}
                                                                shouldDisableDate={disableDates}
                                                            />
                                                        </GridItem>
                                                        <GridItem xs={6} md={6}>
                                                            <IconButton
                                                                size="small"
                                                                classes={{ root: classes.roomRemoveButton }}
                                                                onClick={() => removeDate(index)}
                                                            >
                                                                <IndeterminateCheckBoxIcon />
                                                            </IconButton>
                                                        </GridItem>
                                                    </GridContainer>
                                                ))
                                            }
                                            {!!validateResultsLiveStream.dates && (
                                                <GridContainer>
                                                    <CustomTypography color="danger" className={classes.errorText}>
                                                        {intl.formatMessage({ id: validateResultsLiveStream.dates.message })}
                                                    </CustomTypography>
                                                </GridContainer>
                                            )}
                                            <GridContainer>
                                                <GridItem style={{ marginTop: '10px' }}>
                                                    <IconButton
                                                        size="small"
                                                        classes={{ root: classes.roomAddButton }}
                                                        onClick={addDate}
                                                    >
                                                        <AddBoxIcon />
                                                    </IconButton>
                                                </GridItem>
                                            </GridContainer>
                                        </GridItem>
                                    </GridContainer>
                                    <GridContainer className={classes.padding10}>
                                        <GridItem xs={12} md={3}>
                                            <CustomTypography required>
                                                時間帯
                                            </CustomTypography>
                                        </GridItem>
                                        <GridItem xs={12} md={9} className={classes.time_ranger}>
                                            <TimeRanger
                                                defaultStartTime={defaultParamsLiveStream.stime}
                                                defaultEndTime={defaultParamsLiveStream.etime}
                                                onChangeStartTime={(stime) => handleSeDefaultParamsLiveStream('stime', stime)}
                                                onChangeEndTime={(etime) => handleSeDefaultParamsLiveStream('etime', etime)}
                                                error={{
                                                    stime: !!validateResultsLiveStream.stime,
                                                    etime: !!validateResultsLiveStream.endtime,
                                                    rangerTime: !!validateResultsLiveStream.rangerTime,
                                                }}
                                                helperTexts={{
                                                    stime: validateResultsLiveStream.stime
                                                        ? intl.formatMessage({ id: validateResultsLiveStream.stime.message }) : '',
                                                    etime: validateResultsLiveStream.etime
                                                        ? intl.formatMessage({ id: validateResultsLiveStream.etime.message }) : '',
                                                    rangerTime: validateResultsLiveStream.rangerTime
                                                        ? intl.formatMessage({ id: validateResultsLiveStream.rangerTime.message }) : '',
                                                }}
                                            />
                                        </GridItem>
                                    </GridContainer>

                                    <Box
                                        display="flex"
                                        flexDirection="column"
                                        justify="flex-end"
                                        alignItems="flex-end"
                                    >
                                        <Button color="info" gradient size="md" onClick={addLiveStream}>
                                            登録
                                        </Button>
                                    </Box>
                                    {paramsLivestream.length > 0 && dataTableLiveStream.length > 0 && (
                                        <CustomTable
                                            tableHead={['タイトル', '時間帯', '日程', '有料・無料', 'Action']}
                                            tableHeadWidth={['20%', '20%', '20%', '20%', '20%']}
                                            tableData={dataTableLiveStream}
                                            className={classes.maxHeight}
                                            pointerLess
                                        />
                                    )}
                                </GridItem>
                                <FormHelperText error className={`MuiFormHelperText-contained ${classes.margin28}`}>
                                    {validateResults.live_stream && validateResults.live_stream.result
                                        ? intl.formatMessage({ id: validateResults.live_stream.message }) : ''}
                                </FormHelperText>
                            </GridContainer>
                        </fieldset>
                    </GridItem>
                </GridContainer>
            )}
            {companyDetail.live_stream && companyDetail.live_stream.length > 0 && (
                <GridContainer>
                    <GridItem md={1} />
                    <GridItem xs={12} md={3} />
                    <GridItem xs={12} md={7}>
                        <CustomTable
                            tableHead={['タイトル', '時間帯', '日程', '有料・無料']}
                            tableHeadWidth={['25%', '25%', '25%', '25%']}
                            tableData={liveStreamTable}
                            className={classes.tableEdit}
                            pointerLess
                        />
                    </GridItem>
                </GridContainer>
            )}
        </>
    );

    const handleChangeAds = (value) => {
        handleSetParams('optionAds', value);
        handleSetParams('register_ads_max_change', value);
        if (value <= 0) {
            handleSetParams('register_ads_max', 0);
        }
    };
    const handleInputPostalCode = (valueInput) => {
        handleSetParams('zipCode', valueInput);
        valueInput = valueInput.trim();
        const code = valueInput.substr(0, 3);
        if (code && code.length === 3 && valueInput.length === 7) {
            const pathPostal = process.env.REACT_APP_POSTAL_URL || '';

            fetch(`${pathPostal}/postal/${code}.json`)
            .then((res) => res.json())
            .then((data) => {
                const d = data.find((it) => it[valueInput]);
                handleSetParams('address', d[valueInput][0]);
            }).catch(() => {
                // TODO
            });
        } else {
            handleSetParams('address', '');
        }
    };

    const renderAds = () => (
        <GridContainer className={classes.items}>
            <GridItem md={1} />
            <GridItem xs={12} md={3}>
                <CustomTypography bold>
                    広告申込み
                </CustomTypography>
            </GridItem>
            <GridItem xs={12} md={7}>
                {companyDetail.register_ads_max <= 0
                    ? (
                        <>
                            <RadioGroup
                                aria-label="ads"
                                name="ads"
                                value={params.optionAds}
                                onChange={(e) => handleChangeAds(e.target.value)}
                                row
                                className={classes.groupButton}
                            >
                                <FormControlLabel
                                    value="1"
                                    control={<Radio color="primary" />}
                                    label={<CustomTypography>する</CustomTypography>}
                                />

                                <FormControlLabel
                                    value="0"
                                    control={<Radio color="primary" />}
                                    label={<CustomTypography>しない</CustomTypography>}
                                    className={classes.label}
                                />

                            </RadioGroup>
                            { params.optionAds > 0
                           && (
                               <>
                                   <div style={{ display: 'flex' }}>
                                       <CustomTypography className={classes.paddingLeft15}>
                                           広告搭載申込み件数
                                           <input
                                               value={params.register_ads_max}
                                               onChange={(e) => handleSetParams('register_ads_max', e.target.value)}
                                               type="number"
                                               style={{
                                                   margin: '5px',
                                                   width: '50px',
                                               }}
                                               min={0}
                                           />
                                           件
                                       </CustomTypography>
                                   </div>
                                   <FormHelperText error className={`MuiFormHelperText-contained ${classes.margin28}`}>
                                       {validateResults.register_ads_max && validateResults.register_ads_max.result
                                           ? intl.formatMessage({ id: validateResults.register_ads_max.message }, { minValue: 0, maxValue: eventInfo.register_ads_max }) : ''}
                                   </FormHelperText>
                                   <CustomTypography>
                                       広告募集（1社当り限定）件数
                                       {eventInfo.register_ads_max}
                                       件
                                   </CustomTypography>
                               </>
                           )}
                        </>
                    )
                    : (
                        <CustomTypography>
                            {params.register_ads_max}
                            {' '}
                            件
                        </CustomTypography>
                    )}
            </GridItem>
        </GridContainer>
    );

    const getContent = (check) => (!check ? '本当に削除しますか？' : (
        <>
            <p>本当に削除しますか？</p>
            <p>この企業を削除する場合、この企業のセミナーや商品に関するすべての請求書が承認されなくなります。</p>
        </>
    ));

    return (
        <>
            <FormDialog isOpen={isOpen} handleClose={handleClose} title="出展企業情報修正変更" actions={actionsButton()}>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <GridItem xs={12} sm={12} md={12} style={{ textAlign: 'center' }}>
                            <CustomTypography variant="h4" color="info" bold>
                                {companyDetail.fullName}
                            </CustomTypography>
                        </GridItem>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                        <GridItem xs={12} sm={12} md={12} style={{ textAlign: 'right', marginTop: '20px' }}>
                            <Button
                                color="danger"
                                gradient
                                size="md"
                                style={{ fontSize: '20px' }}
                                onClick={() => setIsOpenDialogDelete({ isOpen: true, noDel: companyDetail.isOrderWaiting })}
                            >
                                この出展者を削除する
                            </Button>
                        </GridItem>
                    </GridItem>
                    <GridItem>
                        <GridContainer className={classes.items}>
                            <GridItem xs={12} md={12}>
                                <CustomTypography variant="h6" bold color="info">
                                    ※出展申込情報
                                </CustomTypography>
                            </GridItem>
                        </GridContainer>
                        {zones.length > 0 && (
                            <GridContainer className={classes.items}>
                                <GridItem md={1} />
                                <GridItem xs={12} sm={4} md={3}>
                                    <CustomTypography bold required>
                                        ゾーン
                                    </CustomTypography>
                                </GridItem>
                                <GridItem xs={12} sm={8} md={7}>
                                    <SelectorInput
                                        valueSelected={params.zone}
                                        optionList={listZoneFromApi}
                                        onChange={(valueInput) => handleSetParams('zone', valueInput)}
                                    />
                                </GridItem>
                            </GridContainer>
                        )}
                        {renderBooth()}
                        {renderSeminar()}
                        {renderLiveStream()}
                        {renderAds()}

                        <GridContainer className={classes.items}>
                            <GridItem xs={12} md={12}>
                                <CustomTypography variant="h6" bold color="info">
                                    ※企業基本情報
                                </CustomTypography>
                            </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.items}>
                            <GridItem md={1} />
                            <GridItem xs={12} sm={4} md={3}>
                                <CustomTypography bold required>
                                    出展企業名
                                </CustomTypography>
                                <CustomTypography>
                                    {!_.isEmpty(eventInfo.languages) ? '（和文）' : '（和文・英文）'}
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} sm={8} md={7}>
                                <CleanableInput
                                    defaultValue={params.fullName}
                                    onChange={(value) => handleSetParams('fullName', value)}
                                    error={!!validateResults.company_full_name}
                                    helperText={validateResults.company_full_name
                                        ? intl.formatMessage({ id: validateResults.company_full_name.message }, { maxLength: 60 }) : ''}
                                />
                            </GridItem>
                        </GridContainer>
                        {!_.isEmpty(eventInfo.languages) && (
                            <GridContainer className={classes.items}>
                                <GridItem md={1} />
                                <GridItem xs={12} sm={4} md={3}>
                                    <CustomTypography bold required>
                                        出展企業名
                                    </CustomTypography>
                                    <CustomTypography>
                                        （英文）
                                    </CustomTypography>
                                </GridItem>
                                <GridItem xs={12} sm={8} md={7}>
                                    <CleanableInput
                                        defaultValue={params.fullNameEN}
                                        onChange={(value) => handleSetParams('fullNameEN', value)}
                                        error={!!validateResults.company_full_name_en}
                                        helperText={validateResults.company_full_name_en
                                            ? intl.formatMessage({ id: validateResults.company_full_name_en.message }, { maxLength: 60 }) : ''}
                                    />
                                </GridItem>
                            </GridContainer>
                        )}
                        <GridContainer className={classes.items}>
                            <GridItem md={1} />
                            <GridItem xs={12} sm={4} md={3}>
                                <CustomTypography bold required>
                                    {!_.isEmpty(eventInfo.languages) ? '社名' : '出展企業名'}
                                </CustomTypography>
                                <CustomTypography>
                                    {!_.isEmpty(eventInfo.languages) ? '（カナ）' : '（カナ・英字）'}
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} sm={8} md={7}>
                                <CleanableInput
                                    defaultValue={params.shortName}
                                    onChange={(value) => handleSetParams('shortName', value)}
                                    error={!!validateResults.company_short_name}
                                    helperText={validateResults.company_short_name
                                        ? intl.formatMessage({ id: validateResults.company_short_name.message }, { maxLength: 60 }) : ''}
                                />
                            </GridItem>
                        </GridContainer>
                        {/* {!_.isEmpty(eventInfo.languages) && (
                            <GridContainer className={classes.items}>
                                <GridItem md={1} />
                                <GridItem xs={12} sm={4} md={3}>
                                    <CustomTypography bold required>
                                        社名
                                    </CustomTypography>
                                    <CustomTypography>
                                        （英字）
                                    </CustomTypography>
                                </GridItem>
                                <GridItem xs={12} sm={8} md={7}>
                                    <CleanableInput
                                        defaultValue={params.shortNameEN}
                                        onChange={(value) => handleSetParams('shortNameEN', value)}
                                        error={!!validateResults.company_short_name_en}
                                        helperText={validateResults.company_short_name_en
                                            ? intl.formatMessage({ id: validateResults.company_short_name_en.message }, { maxLength: 60 }) : ''}
                                    />
                                </GridItem>
                            </GridContainer>
                        )} */}

                        { ( category?.length > 1  )  &&  (  
                        <GridContainer className={classes.items}>
                            <GridItem md={1} />
                            <GridItem xs={12} sm={4} md={3}>
                                <CustomTypography bold >
                                出展エリア(分類-カテゴリ分け)
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} sm={5} md={5}>
                                <SelectorInput
                                    optionList={categoryState}
                                    valueSelected={`${params.companyCategory}`}
                                    onChange={(value) => handleSetParams('companyCategory', value)}
                                />
                            </GridItem>
                        </GridContainer>
                        ) }

                        <GridContainer className={classes.items}>
                            <GridItem md={1} />
                            <GridItem xs={12} sm={4} md={3}>
                                <CustomTypography bold required>
                                    業種
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} sm={5} md={5}>
                                <SelectorInput
                                    optionList={jobStates}
                                    valueSelected={`${params.companyType}`}
                                    onChange={(value) => handleSetParams('companyType', value)}
                                    error={!!validateResults.company_type}
                                    helperText={validateResults.company_type
                                        ? intl.formatMessage({ id: validateResults.company_type.message }, { maxLength: 255 }) : ''}
                                />
                            </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.items}>
                            <GridItem md={1} />
                            <GridItem xs={12} sm={4} md={3}>
                                <CustomTypography bold required>
                                    職種
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} sm={5} md={5}>
                                <SelectorInput
                                    optionList={occupationStates}
                                    valueSelected={`${params.occupationName}`}
                                    onChange={(value) => handleSetParams('occupationName', value)}
                                    error={!!validateResults.occupation_name}
                                    helperText={validateResults.occupation_name
                                        ? intl.formatMessage({ id: validateResults.occupation_name.message }) : ''}
                                />
                            </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.items}>
                            <GridItem md={1} />
                            <GridItem xs={12} sm={4} md={3}>
                                <CustomTypography bold required>
                                    従業員数
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} sm={5} md={5}>
                                <SelectorInput
                                    optionList={listOptionEmployeeNumberFromApi}
                                    valueSelected={params.employee_number}
                                    onChange={(value) => handleSetParams('employee_number', value)}
                                    error={!!validateResults.employee_number}
                                    helperText={validateResults.employee_number
                                        ? intl.formatMessage({ id: validateResults.employee_number.message }, { maxLength: 255 }) : ''}
                                />
                            </GridItem>
                        </GridContainer>

                        <GridContainer className={classes.items}>
                            <GridItem>
                                <CustomTypography variant="h6" bold color="info">
                                    ※連絡担当者情報
                                </CustomTypography>
                            </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.items}>
                            <GridItem md={1} />
                            <GridItem xs={12} sm={4} md={3}>
                                <CustomTypography bold>
                                    部署
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} sm={8} md={7}>
                                <CleanableInput
                                    defaultValue={params.department}
                                    onChange={(value) => handleSetParams('department', value)}
                                    error={!!validateResults.department}
                                    helperText={validateResults.department
                                        ? intl.formatMessage({ id: validateResults.department.message }, { maxLength: 255 }) : ''}
                                />
                            </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.items}>
                            <GridItem md={1} />
                            <GridItem xs={12} sm={4} md={3}>
                                <CustomTypography bold>
                                    役職
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} sm={8} md={7}>
                                <CleanableInput
                                    defaultValue={params.position}
                                    onChange={(value) => handleSetParams('position', value)}
                                    error={!!validateResults.position}
                                    helperText={validateResults.position
                                        ? intl.formatMessage({ id: validateResults.position.message }, { maxLength: 255 }) : ''}
                                />
                            </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.items}>
                            <GridItem md={1} />
                            <GridItem xs={12} sm={4} md={3}>
                                <CustomTypography bold>
                                    氏名
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} sm={8} md={7}>
                                <GridContainer>
                                    <GridItem xs={12} md={6} style={{ paddingLeft: 0 }}>
                                        <CleanableInput
                                            defaultValue={params.firstName}
                                            onChange={(value) => handleSetParams('firstName', value)}
                                            error={!!validateResults.first_name}
                                            helperText={validateResults.first_name
                                                ? intl.formatMessage({ id: validateResults.first_name.message }, { maxLength: 255 }) : ''}
                                        />
                                    </GridItem>
                                    <GridItem xs={12} md={6} style={{ paddingLeft: 0, paddingRight: 0 }}>
                                        <CleanableInput
                                            defaultValue={params.lastName}
                                            onChange={(value) => handleSetParams('lastName', value)}
                                            error={!!validateResults.last_name}
                                            helperText={validateResults.last_name
                                                ? intl.formatMessage({ id: validateResults.last_name.message }, { maxLength: 255 }) : ''}
                                        />
                                    </GridItem>
                                </GridContainer>
                            </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.items}>
                            <GridItem md={1} />
                            <GridItem xs={12} sm={4} md={3}>
                                <CustomTypography bold>
                                    国・地域
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} sm={5} md={5}>
                                <SelectorInput
                                    valueSelected={params.location}
                                    optionList={locationOption.ja}
                                    onChange={(valueInput) => handleSetParams('location', valueInput)}
                                    error={!!validateResults.location}
                                    helperText={validateResults.location
                                        ? intl.formatMessage({ id: validateResults.location.message }, { maxLength: 255 }) : ''}
                                />
                            </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.items}>
                            <GridItem md={1} />
                            <GridItem xs={12} sm={4} md={3}>
                                <CustomTypography bold required>
                                    郵便番号
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} sm={8} md={7}>
                                <GridContainer>
                                    <GridItem xs={12} sm={6} md={6} style={{ paddingLeft: 0 }}>
                                        <CleanableInput
                                            isFullWidth
                                            defaultValue={params.zipCode}
                                            onChange={(valueInput) => handleInputPostalCode(valueInput)}
                                            error={!!validateResults.zip_code}
                                            helperText={validateResults.zip_code
                                                ? intl.formatMessage({ id: validateResults.zip_code.message }, { maxLength: 255 }) : ''}
                                        />
                                    </GridItem>
                                </GridContainer>
                            </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.items}>
                            <GridItem md={1} />
                            <GridItem xs={12} sm={4} md={3}>
                                <CustomTypography bold required>
                                    {!_.isEmpty(eventInfo.languages) ? '住所（和文）' : '住所'}
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} sm={8} md={7}>
                                <CleanableInput
                                    defaultValue={params.address}
                                    onChange={(valueInput) => handleSetParams('address', valueInput)}
                                    error={!!validateResults.address}
                                    helperText={validateResults.address
                                        ? intl.formatMessage({ id: validateResults.address.message }, { maxLength: 1000 }) : ''}
                                />
                            </GridItem>
                        </GridContainer>
                        {!_.isEmpty(eventInfo.languages) && (
                            <GridContainer className={classes.items}>
                                <GridItem md={1} />
                                <GridItem xs={12} sm={4} md={3}>
                                    <CustomTypography bold required>
                                        住所（英文）
                                    </CustomTypography>
                                </GridItem>
                                <GridItem xs={12} sm={8} md={7}>
                                    <CleanableInput
                                        defaultValue={params.addressEN}
                                        onChange={(valueInput) => handleSetParams('addressEN', valueInput)}
                                        error={!!validateResults.address_en}
                                        helperText={validateResults.address_en
                                            ? intl.formatMessage({ id: validateResults.address_en.message }, { maxLength: 1000 }) : ''}
                                    />
                                </GridItem>
                            </GridContainer>
                        )}

                        <GridContainer className={classes.items}>
                            <GridItem md={1} />
                            <GridItem xs={12} sm={4} md={3}>
                                <CustomTypography bold required>
                                    電話番号
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} sm={8} md={7}>
                                <GridContainer>
                                    <GridItem xs={12} sm={6} md={6} style={{ paddingLeft: 0 }}>
                                        <CleanableInput
                                            isFullWidth
                                            defaultValue={params.phoneNumber}
                                            onChange={(valueInput) => handleSetParams('phoneNumber', valueInput)}
                                            error={!!validateResults.phoneNumber}
                                            helperText={validateResults.phoneNumber
                                                ? intl.formatMessage({ id: validateResults.phoneNumber.message }, { maxLength: 255 }) : ''}
                                        />
                                    </GridItem>
                                </GridContainer>
                            </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.items}>
                            <GridItem md={1} />
                            <GridItem xs={12} sm={4} md={3}>
                                <CustomTypography bold>
                                    FAX 番号
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} sm={8} md={7}>
                                <GridContainer>
                                    <GridItem xs={12} sm={6} md={6} style={{ paddingLeft: 0 }}>
                                        <CleanableInput
                                            defaultValue={params.faxNumber}
                                            onChange={(valueInput) => handleSetParams('faxNumber', valueInput)}
                                            error={!!validateResults.fax_number}
                                            helperText={validateResults.fax_number
                                                ? intl.formatMessage({ id: validateResults.fax_number.message }, { maxLength: 255 }) : ''}
                                        />
                                    </GridItem>
                                </GridContainer>
                            </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.items}>
                            <GridItem md={1} />
                            <GridItem xs={12} sm={4} md={3}>
                                <CustomTypography bold>
                                    ＵＲＬ
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} sm={8} md={7}>
                                <CleanableInput
                                    defaultValue={params.url}
                                    onChange={(valueInput) => handleSetParams('url', valueInput)}
                                    error={!!validateResults.url}
                                    helperText={validateResults.url
                                        ? intl.formatMessage({ id: validateResults.url.message }, { maxLength: 500 }) : ''}
                                />
                            </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.items}>
                            <GridItem md={1} />
                            <GridItem xs={12} sm={4} md={3}>
                                <CustomTypography bold>
                                    ガイド画像
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} sm={8} md={7}>
                                <GridContainer direction="column" justify="flex-start" alignItems="flex-start">
                                    <UploadButton
                                        imagePreview={previewImage}
                                        type="image"
                                        text="Upload an Image"
                                        onChange={(value) => handleUploadImage(value)}
                                        isHasClear
                                    />
                                </GridContainer>
                            </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.items}>
                            <GridItem md={1} />
                            {!_.isEmpty(eventInfo.languages) ? (
                                <GridItem xs={12} sm={4} md={3}>
                                    <CustomTypography bold required>
                                        ガイド情報
                                    </CustomTypography>
                                </GridItem>
                            ) : (
                                <GridItem xs={12} sm={4} md={3}>
                                    <CustomTypography bold required>
                                        ガイド情報
                                    </CustomTypography>
                                    <CustomTypography>
                                        （和文）
                                    </CustomTypography>
                                </GridItem>
                            )}
                            <GridItem xs={12} sm={8} md={7}>
                                <CleanableInput
                                    defaultValue={params.description}
                                    isMultiline
                                    onChange={(valueInput) => handleSetParams('description', valueInput)}
                                    error={!!validateResults.description}
                                    helperText={validateResults.description
                                        ? intl.formatMessage({ id: validateResults.description.message }, { maxLength: 1000 }) : ''}
                                />
                            </GridItem>
                        </GridContainer>
                        {!_.isEmpty(eventInfo.languages) && (
                            <GridContainer className={classes.items}>
                                <GridItem md={1} />
                                <GridItem xs={12} sm={4} md={3}>
                                    <CustomTypography bold required>
                                        ガイド情報
                                    </CustomTypography>
                                    <CustomTypography>
                                        （英文）
                                    </CustomTypography>
                                </GridItem>
                                <GridItem xs={12} sm={8} md={7}>
                                    <CleanableInput
                                        defaultValue={params.descriptionEN}
                                        isMultiline
                                        onChange={(valueInput) => handleSetParams('descriptionEN', valueInput)}
                                        error={!!validateResults.description_en}
                                        helperText={validateResults.description_en
                                            ? intl.formatMessage({ id: validateResults.description_en.message }, { maxLength: 1000 }) : ''}
                                    />
                                </GridItem>
                            </GridContainer>
                        )}
                        <GridContainer className={classes.itemPayment} alignItems="center">
                            <GridItem md={1} />
                            <GridItem xs={12} sm={4} md={3}>
                                <CustomTypography bold required>
                                    支払い方法
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} sm={8} md={7}>
                                <RadioGroup
                                    name="has_payment"
                                    value={params.has_payment}
                                    onChange={(e) => handleSetParams('has_payment', e.target.value)}
                                    row
                                >
                                    <FormControlLabel
                                        value="1"
                                        control={<Radio color="primary" />}
                                        label={<CustomTypography>クレジット</CustomTypography>}
                                    />
                                    <FormControlLabel
                                        value="2"
                                        control={<Radio color="primary" />}
                                        label={<CustomTypography>銀行口座</CustomTypography>}
                                        className={classes.label}
                                    />
                                </RadioGroup>
                            </GridItem>
                        </GridContainer>
                        {validateResults.has_payment && validateResults.has_payment.result ? (
                            <GridContainer>
                                <GridItem md={1} />
                                <GridItem xs={12} sm={4} md={3} />
                                <GridItem xs={12} sm={8} md={7}>
                                    <FormHelperText error className={`MuiFormHelperText-contained ${classes.margin28}`}>
                                        {validateResults.has_payment && validateResults.has_payment.result
                                            ? 'お支払い方法をお選びください。' : ''}
                                    </FormHelperText>
                                </GridItem>
                            </GridContainer>
                        ) : ''}
                    </GridItem>
                </GridContainer>
            </FormDialog>
            <SnackBar
                open={snackbar.isOpen}
                onClose={handleCloseSnackbar}
                message={snackbar.message}
                severity={snackbar.type}
                autoHideDuration={3000}
            />
            <AlertDialog
                title={<FormattedMessage id="dialog.confirmDeleteTitle" />}
                handleClose={() => setIsOpenDialogDelete({ isOpen: false, noDel: false })}
                handleOpen={isOpenDialogDelete.isOpen}
                handleSubmit={handleDeleteCompany}
                contents={getContent(isOpenDialogDelete.noDel)}
            />
        </>
    );
};

DialogEditCompany.defaultProps = {
    companyDetail: {},
    room: {},
    eventInfo: {},
    errorEdit: {},
    deleteSuccess: {},
    options: {},
    fetchJobs: () => {},
    jobs: {},
    fetchCategory: () => {},
    category: {},
    errorDeleteCompany: {},
    getOccupations: () => {},
    occupations: {},
    clearOccupations: {},
};

DialogEditCompany.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    companyDetail: PropTypes.oneOfType([() => null, PropTypes.object]),
    room: PropTypes.oneOfType([() => null, PropTypes.object]),
    eventInfo: PropTypes.oneOfType([() => null, PropTypes.object]),
    errorEdit: PropTypes.oneOfType([() => null, PropTypes.object]),
    deleteSuccess: PropTypes.oneOfType([() => null, PropTypes.object]),
    options: PropTypes.oneOfType([() => null, PropTypes.object]),
    fetchEditCompany: PropTypes.func.isRequired,
    getInformationRoom: PropTypes.func.isRequired,
    fetchDeleteCompany: PropTypes.func.isRequired,
    clearDeleteCompany: PropTypes.func.isRequired,
    fetchJobs: PropTypes.func,
    jobs: PropTypes.oneOfType([() => null, PropTypes.object]),
    fetchCategory: PropTypes.func,
    category: PropTypes.oneOfType([() => null, PropTypes.object]),
    zones: PropTypes.oneOfType([null, PropTypes.array]).isRequired,
    eventStartDate: PropTypes.string.isRequired,
    eventEndDate: PropTypes.string.isRequired,
    errorDeleteCompany: PropTypes.oneOfType([() => null, PropTypes.object]),
    getOccupations: PropTypes.func,
    occupations: PropTypes.oneOfType([() => null, PropTypes.object]),
    clearOccupations: PropTypes.func,
};

export default DialogEditCompany;
